import {until} from 'lit-html/directives/until';
import {LoadingEllipses} from '@epg/epg-components';
import {formLabels, toastStatus} from '@modules/i18n-labels';
import {generalLabels} from '@modules/i18n-labels';

export default (ctx, html) => html`
<div class="modal" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header flex-column">
        <button type="button" focusfirst class="close text-body" aria-label="Close" @click="${ctx.close}">
          <span class="ai ai-close-icon h4"></span>
        </button>
      </div>
      <div class="modal-body w-75 mx-auto px-0 overflow-hidden">
       <div class="d-flex justify-content-between">
          <div class="h4" tabindex="0">${until(ctx.__('<tt-f2D43Zxf>', 'Change Login Email'))}</div>
       </div>
       <div class="">${until(ctx.__('<tt-zHXXMsip>', 'Please provide the new email you would like to change your login credentials to, and confirm your password.'))}</div>
        <form class="horizontal-form mb-5 mt-5" @submit="${ctx.submit}" novalidate autocomplete="off">
          <div class="form-group row mb-2">
            <span class="col-sm-10 d-inline">${until(ctx._r(ctx.__('<tt-8WRcKqR+>', 'Current login email: %r1%'), ctx.currentEmail))}</span>
          </div>
          <div class="form-group row mb-5">
            <label for="email" class="col-sm-3 col-form-label">*${until(ctx.__('<tt-/k6jp6zB>', 'New Login Email'))}</label>
            <div class="col-sm-8">
             <input type="email" name="email" class="form-control form-control-sm ${!ctx.form.email.valid? 'is-invalid': ''}" id="email" @input="${ctx.emailUpdated}" @blur="${ctx.validateEmail}" required>
             ${(!ctx.form.email.emailLike.valid)? html`<p class="invalid-feedback col-sm-8 offset-sm-0 d-block mb-0 pl-0 inline-error">${until(generalLabels.invalidEmailError)}</p>`: ''}
             ${(!ctx.form.email.same.valid)? html`<p class="invalid-feedback col-sm-8 offset-sm-0 d-block mb-0 pl-0 inline-error">${until(ctx.__('<tt-Bkpp9EhD>', 'Email must be different.'))}</p>`: ''}
             ${(ctx.conflictingEmail)? html`<p class="invalid-feedback col-sm-8 offset-sm-0 d-block mb-0 pl-0 inline-error">${until(toastStatus.duplicateEmail)}</p>`: ''}

            </div>

          </div>
          <div class="form-group row mb-5">
            <label for="password" class="col-sm-3 col-form-label">*${until(ctx.__('<tt-x3+h4zm7>', 'Password'))}</label>
            <div class="col-sm-8">
              <input
                id="password"
                name="password"
                value=""
                type="password"
                placeholder=""
                required
                class="form-control form-control-sm ${!ctx.form.password.valid? 'is-invalid': ''}"
                @input="${ctx.updatePassword}"
                @blur="${ctx.updatePassword}">
                ${!ctx.form.password.isRequired.valid? html`<p class="invalid-feedback col-sm-8 offset-sm-0 d-block mb-0 pl-0 inline-error">${until(ctx.__('<tt-bLRQiQyE>', 'Password is required.'))}</p>`: ''}
                ${ctx.invalidCredentials? html`<p class="invalid-feedback col-sm-8 offset-sm-0 d-block mb-0 pl-0 inline-error">${until(ctx.__('<tt-NyqDCw9b>', 'Invalid Password.'))}</p>`: ''}
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-6 col-sm-4 offset-sm-2">
              <button focuslast type="button" class="btn btn-outline-primary btn-block rounded-pill" @click="${ctx.close}">${until(generalLabels.cancel)}</button>
            </div>
            <div class="col-6 col-sm-4">
              <button type="submit" @click="${ctx.onSubmit}" ?disabled="${!ctx.password || ctx.submitting || !ctx.form.valid}" class="btn btn-primary btn-block rounded-pill ${ !ctx.password ? 'disabled' : ''}">${until(formLabels.submit)}</button>
            </div>
        </form>

      </div>
    </div>
  </div>
</div>
`;
